/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationChannelWebhookUrl } from './NotificationChannelWebhookUrl';
import {
    NotificationChannelWebhookUrlFromJSON,
    NotificationChannelWebhookUrlFromJSONTyped,
    NotificationChannelWebhookUrlToJSON,
    NotificationChannelWebhookUrlToJSONTyped,
} from './NotificationChannelWebhookUrl';
import type { NotificationChannelEmail } from './NotificationChannelEmail';
import {
    NotificationChannelEmailFromJSON,
    NotificationChannelEmailFromJSONTyped,
    NotificationChannelEmailToJSON,
    NotificationChannelEmailToJSONTyped,
} from './NotificationChannelEmail';
import type { ChannelTypeEnum } from './ChannelTypeEnum';
import {
    ChannelTypeEnumFromJSON,
    ChannelTypeEnumFromJSONTyped,
    ChannelTypeEnumToJSON,
    ChannelTypeEnumToJSONTyped,
} from './ChannelTypeEnum';

/**
 * Serializer for notification channels.
 * @export
 * @interface NotificationChannelRequest
 */
export interface NotificationChannelRequest {
    /**
     * 
     * @type {number}
     * @memberof NotificationChannelRequest
     */
    owner?: number | null;
    /**
     * 
     * @type {ChannelTypeEnum}
     * @memberof NotificationChannelRequest
     */
    channelType: ChannelTypeEnum;
    /**
     * 
     * @type {NotificationChannelEmail}
     * @memberof NotificationChannelRequest
     */
    email?: NotificationChannelEmail | null;
    /**
     * 
     * @type {NotificationChannelWebhookUrl}
     * @memberof NotificationChannelRequest
     */
    webhookUrl?: NotificationChannelWebhookUrl | null;
}



/**
 * Check if a given object implements the NotificationChannelRequest interface.
 */
export function instanceOfNotificationChannelRequest(value: object): value is NotificationChannelRequest {
    if ((!('channelType' in (value as Record<string, any>)) && !('channel_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['channelType'] === undefined && (value as Record<string, any>)['channel_type'] === undefined)) return false;
    return true;
}

export function NotificationChannelRequestFromJSON(json: any): NotificationChannelRequest {
    return NotificationChannelRequestFromJSONTyped(json, false);
}

export function NotificationChannelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationChannelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'channelType': ChannelTypeEnumFromJSON(json['channel_type']),
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : NotificationChannelEmailFromJSON(json['email']),
        'webhookUrl': json['webhook_url'] === undefined ? undefined : json['webhook_url'] === null ? null : NotificationChannelWebhookUrlFromJSON(json['webhook_url']),
    };
}

export function NotificationChannelRequestToJSON(json: any): NotificationChannelRequest {
    return NotificationChannelRequestToJSONTyped(json, false);
}

export function NotificationChannelRequestToJSONTyped(value?: NotificationChannelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'channel_type': ChannelTypeEnumToJSON(value['channelType']),
        'email': NotificationChannelEmailToJSON(value['email']),
        'webhook_url': NotificationChannelWebhookUrlToJSON(value['webhookUrl']),
    };
}

